import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import { ref, onValue, set, remove, push } from "firebase/database";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";

// التحقق من Electron
const isElectron = () => window.electronAPI !== undefined;

// Styles
const inputStyle = { padding: 8, border: "1px solid #ccc", borderRadius: 6, width: "100%" };
const btnStyle = { padding: "8px 14px", background: "#007bff", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer" };

export default function BrandsPage({ uid }) {
  const [brands, setBrands] = useState([]);
  const [name, setName] = useState("");
  const [refCode, setRefCode] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(true);

  // تحميل البراندات
  const loadBrands = async () => {
    setLoading(true);
    
    if (isElectron()) {
      const sqliteBrands = await window.electronAPI.getBrands();
      setBrands(sqliteBrands || []);
    } else {
      const brandsRef = ref(db, `distributors/${uid}/brands`);
      onValue(brandsRef, (snap) => {
        const val = snap.val();
        const firebaseBrands = val ? Object.keys(val).map(id => ({ id, ...val[id] })) : [];
        setBrands(firebaseBrands);
        setLoading(false);
      });
      setLoading(false);
      return;
    }
    setLoading(false);
  };

  // معالجة الصورة
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  // رفع الصورة إلى Firebase Storage
  const uploadImage = async () => {
    if (!imageFile) return "";
    
    const storage = getStorage();
    const imgRef = storageRef(storage, `brands/${uid}/${Date.now()}_${imageFile.name}`);
    await uploadBytes(imgRef, imageFile);
    return await getDownloadURL(imgRef);
  };

  // إضافة أو تعديل براند
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return alert("الرجاء إدخال اسم الماركة");

    try {
      let imageUrl = previewUrl;
      
      // رفع الصورة جديدة إذا وجدت
      if (imageFile) {
        imageUrl = await uploadImage();
      }

      if (isElectron()) {
        // ✅ وضع Electron (SQLite)
        if (editId) {
          // تعديل
          await window.electronAPI.updateBrand({ 
            id: editId, 
            name: name.trim(),
            ref: refCode,
            imageUrl: imageUrl
          });
          alert("✅ تم التعديل بنجاح (محلياً)");
        } else {
          // إضافة جديدة
          const result = await window.electronAPI.addBrand({ 
            name: name.trim(),
            ref: refCode,
            imageUrl: imageUrl
          });
          if (result.success) {
            alert("✅ تمت إضافة الماركة بنجاح (محلياً)");
          }
        }
      } else {
        // ✅ متصفح عادي (Firebase)
        const brandId = editId || push(ref(db, `distributors/${uid}/brands`)).key;
        await set(ref(db, `distributors/${uid}/brands/${brandId}`), {
          id: brandId,
          name: name.trim(),
          ref: refCode,
          imageUrl: imageUrl,
          createdAt: Date.now(),
        });
        alert(editId ? "✅ تم التعديل بنجاح" : "✅ تمت الإضافة بنجاح");
      }

      // ✅ مسح الحقول
      setName("");
      setRefCode("");
      setImageFile(null);
      setPreviewUrl("");
      setEditId(null);
      
      // ✅ إعادة تحميل القائمة
      await loadBrands();
      
    } catch (error) {
      console.error(error);
      alert("❌ خطأ: " + error.message);
    }
  };

  // حذف براند
  const handleDelete = async (id, name) => {
    if (!window.confirm(`حذف "${name}" ؟`)) return;

    try {
      if (isElectron()) {
        await window.electronAPI.deleteBrand(id);
      }
      await remove(ref(db, `distributors/${uid}/brands/${id}`));
      alert("✅ تم الحذف بنجاح");
      await loadBrands();
    } catch (error) {
      alert("❌ خطأ في الحذف");
    }
  };

  // تعديل (تعبئة النموذج)
  const handleEdit = (brand) => {
    setName(brand.name || "");
    setRefCode(brand.ref || "");
    setPreviewUrl(brand.imageUrl || "");
    setEditId(brand.id);
    setImageFile(null);
  };

  // إلغاء التعديل
  const handleCancel = () => {
    setName("");
    setRefCode("");
    setImageFile(null);
    setPreviewUrl("");
    setEditId(null);
  };

  useEffect(() => {
    loadBrands();
  }, [uid]);

  if (loading && brands.length === 0) {
    return <div style={{ padding: 24 }}>Chargement...</div>;
  }

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 24 }}>
      <h2 style={{ marginBottom: 20 }}>Mes Marques</h2>

      {/* وضع التشغيل */}
      {isElectron() && (
        <div style={{
          background: "#e0f2fe",
          padding: "8px 12px",
          borderRadius: 6,
          marginBottom: 16,
          fontSize: 12,
        }}>
          💾 Mode hors ligne - Les données sont en SQLite
        </div>
      )}

      {/* نموذج الإضافة/التعديل */}
      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 20 }}>
        <input
          placeholder="اسم الماركة *"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={inputStyle}
          required
        />
        <input
          placeholder="Ref Code (اختياري)"
          value={refCode}
          onChange={(e) => setRefCode(e.target.value)}
          style={inputStyle}
        />
        <input type="file" accept="image/*" onChange={handleImageChange} style={inputStyle} />
        {previewUrl && (
          <img src={previewUrl} alt="Preview" style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 8 }} />
        )}
        <div style={{ display: "flex", gap: 10 }}>
          <button type="submit" style={{ ...btnStyle, background: "#28a745" }}>
            {editId ? "Modifier" : "Ajouter"}
          </button>
          {editId && (
            <button type="button" onClick={handleCancel} style={{ ...btnStyle, background: "#6c757d" }}>
              Annuler
            </button>
          )}
        </div>
      </form>

      {/* قائمة الماركات */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
        {brands.length === 0 && <p>Aucune marque disponible.</p>}

        {brands.map((b) => (
          <div
            key={b.id}
            style={{
              border: "1px solid #ccc",
              borderRadius: 8,
              padding: 12,
              width: 200,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              background: "#f9f9f9",
            }}
          >
            {b.imageUrl && (
              <img
                src={b.imageUrl}
                alt={b.name}
                style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 8, marginBottom: 8 }}
              />
            )}
            <div style={{ fontWeight: "bold", marginBottom: 4 }}>{b.name}</div>
            {b.ref && <div style={{ fontSize: 11, color: "#555", marginBottom: 8 }}>{b.ref}</div>}
            <div style={{ display: "flex", gap: 8 }}>
              <button
                onClick={() => handleEdit(b)}
                style={{ padding: "6px 12px", background: "#007bff", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer" }}
              >
                تعديل
              </button>
              <button
                onClick={() => handleDelete(b.id, b.name)}
                style={{ padding: "6px 12px", background: "#dc3545", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer" }}
              >
                حذف
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}